var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgHeartSticker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6408 3.88789C13.1384 2.52518 10.9258 2.78613 9.53267 4.2938L9.01366 4.87367L8.46733 4.2938C7.10152 2.78613 4.8616 2.52518 3.3592 3.88789C1.63828 5.45355 1.55633 8.23694 3.08604 9.91857L8.38539 15.7173C8.71318 16.0942 9.28682 16.0942 9.61461 15.7173L14.914 9.91857C16.4437 8.23694 16.3617 5.45355 14.6408 3.88789Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartSticker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart-sticker.883ead2e9c26a9d49decf385c3e86bd2.svg";